import styled from "styled-components";
import { getHexOpacity } from "../../../../../utils/pipes";

export const ModalChangeProgramStatus = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  height: 100%;
  width: 100%;
  .modal-background {
    background-color: ${`#090949${getHexOpacity(0.50)}`};
    height: 100%;
    width: 100%;
    position: absolute;
    z-index: 100;
  }
  .modal-container {
    z-index: 200;
    background-color: var(--white);
    width: 100%;
    margin-top: auto;
    height: 90%;
    max-height: 90%;
    border-radius: 14px;
    box-sizing: border-box;
    &--response {
      padding: 40px;
    }
    .header {
      display: flex;
      padding: 20px 40px;
      border-bottom: 1px solid #E0E6ED;
      align-items: center;
      .title {
        display: flex;
        align-items: center;
        color: #1F1F52;
        font-family: Nunito Sans Extrabold;
        font-size: 20px;
      }
      .description {
        font-family: Nunito Sans;
        font-size: 13px;
        color: #3E3E5B;
      }
      .close {
        height: 36px;
        width: 36px;
        border-radius: 14px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #EFEFF9;
        cursor: pointer;
        outline: none;
        border: none;
        color: #0C0AA2;
        font-size: 10px;
        margin-right: 10px;
      }
    }
    .footer {
      display: flex;
      padding: 10px 40px;
      justify-content: space-between;
      border-top: 2px solid #F0EFF9;
      align-items: center;
      &__description {
        display: flex;
        align-items: center;
        &-icon {
          margin-right: 10px;
          display: flex;
          align-items: center;
          font-size: 16px;
          color: #3E3DA3;
        }
        &-text {
          font-family: Nunito Sans;
          font-size: 18px;
          font-weight: 200;
          color: #707582;
          height: 100%;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      &__buttons {
        display: flex;
        margin-left: 50px;
        align-items: center;
        .button-container {
          min-width: 140px;
          margin-left: 10px;
        }
        .button-separator {
          border-left: 1px solid #3E3E5B;
          height: 7px;
          margin-left: 10px;
        }
      }
    }

    .content {
      height: ${({programSelected}) => programSelected ? "calc(100% - 86px - 58px)" : "calc(100% - 86px)"};  
      overflow: auto;
      background-color: #F0EFF9;
      padding: 40px; 
      box-sizing: border-box;
      display: flex;
      &__patient-card {
        justify-content: ${({programSelected}) => programSelected ? "" : "center"};  
        background-color: #FFF;
        border-radius: 20px;
        margin-right: 20px;
        padding: 20px;
        width: 357px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .program-info {
          justify-content: center;
          align-items: center;
          text-align: center;
          margin-bottom: 24px;
          &__label {
            font-family: Nunito Sans;
            font-size: 17px;
            color: #3E3E5B;
          }
          &__program-selected {
            color: #3E3E5B;
            font-family: Nunito Sans Light;
            font-size: 25px;
          }
        }
        .patient-image {
          width: 297px;
          height: 379px;
          position: relative;
          &__border {
            height: 370px;
            width: 288px;
            border: 5px solid #FFFFFF80;
            position: absolute;
            border-radius: 176px;
          }
          &__img {
            display: flex;
            width: 100%;
            height: 100%;
            border-radius: 176px;
            object-fit: cover;
          }
          &__img-shadow {
            position: absolute;
            width: 110%;
            height: 105%;
            border-radius: 176px;
            top: -5px;
            opacity: 0.3;
            filter: blur(30px);
            left: -22px;
            z-index: -1;
          }
        }
        .patient-principal-info {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          font-size: 25px;
          margin-top: 20px;
          .patient-name {
            text-align: center;
            line-height: 25px;
            font-family: "Nunito Sans Light";
            background: linear-gradient(97.31deg, #FC7AAC -6.15%, #D16CC2 9.57%, #AC61D4 26.6%, #8D58E4 42.32%, #7651F0 59.36%, #654BF8 77.7%, #5C48FD 98.66%, #5948FF 124.86%);
            color: transparent;
            background-clip: text;
          }
          .patient-info {
            display: flex;
            color: #3E3E5B;
            align-items: center;
            &__separator {
              margin: 0 10px;
              height: 7px;
              border-right: 1px solid #CFD3DD;
            }
            &__id-number {
              font-size: 20px;
            }
          }
        }
      }

      &__change-form {
        background-color: #FFF;
        margin: 20px 20px 0;
        border-top-right-radius: 14px;
        border-top-left-radius: 14px;
        padding: 20px;
        height: ${({programSelected}) => programSelected ? "calc(100% - 180px)" : "calc(100% - 210px)"};  
        .status-data {
          display: flex;
          flex-direction: column;
          overflow: auto;
          height: calc(100% - 59px);
        }
        .status-info {
          margin-top: 40px;
          display: flex;
          align-items: center;
          margin-bottom: 40px;
          &__icon {
            color: #8A8AC3;
            margin-right: 10px;
          }
          &__text {
            font-family: Nunito Sans;
            font-size: 18px;
            color: #707582;
          }
        }
      }
    }

  }  
  
`;